// This icon file is generated automatically.
var QuitOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M179.31 94.39l-.03-.03-26.87-26.87c-1.49-1.5-3.5-2.32-5.66-2.32s-4.17.83-5.66 2.32a8.12 8.12 0 000 11.32L154.27 92H79.6a8 8 0 000 16h74.77l-13.28 13.29a8.12 8.12 0 000 11.32 8 8 0 005.66 2.3 8 8 0 005.66-2.3l26.9-26.9a8.12 8.12 0 000-11.32zM140.4 141.9a8 8 0 00-7.69 5.8h-.31v21.8a4 4 0 01-4 4h-90a4 4 0 01-4-4v-139a4 4 0 014-4h90a4 4 0 014 4V55h.26a8 8 0 007.74 6 8 8 0 007.74-6h.26V30.5c0-11.03-8.97-20-20-20h-90c-11.03 0-20 8.97-20 20v139c0 11.03 8.97 20 20 20h90c11.03 0 20-8.97 20-20v-21.8h-.32a8 8 0 00-7.68-5.8z" } }] }, "name": "quit", "theme": "outlined" };
export default QuitOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/QuitOutlined.js
// module id = 3961
// module chunks = 0